import whatsapp from "@/assets/icons/WhatsApp.svg";
import map from "@/assets/icons/maps.svg";
import instagram from "@/assets/icons/instagram.svg";
import facebook from "@/assets/icons/Facebook.svg";
import tiktok from "@/assets/icons/tiktok.svg";
import Card from "./VCard_card";
import SocialIcon from "./SocialIcon";
//
export default function CardsHolder() {
  return (
    <div className="flex flex-col items-stretch gap-y-4 sm:gap-y-5 w-full max-w-full sm:max-w-xl mx-auto px-4 sm:px-6 min-h-0">
      <div className="flex flex-row justify-center gap-4">
        <SocialIcon
          logo={instagram}
          title="Instagram"
          link="https://www.instagram.com/elverdecomidacostena/"
        />
        <SocialIcon
          logo={facebook}
          title="Facebook"
          link="https://www.facebook.com/elverdecomidacostena"
        />
        <SocialIcon
          logo={tiktok}
          title="TikTok"
          link="https://www.tiktok.com/@elverdecomidacostena"
        />
      </div>

      <div className="grid gap-y-4">
        <h2 className="text-xl font-extrabold text-white tracking-wide uppercase border-l-4 border-accent pl-3 bg-white/10 rounded-r-lg py-2">
          Local Ordóñez Lasso
        </h2>
        <Card
          logo={map}
          title="Ver en Google Maps"
          description="Abrir ubicación en Google Maps"
          link="https://maps.app.goo.gl/ViHb623s7Y2gP1kQ9?g"
        />
        <Card
          logo={whatsapp}
          title="Whatsapp"
          description="Contáctanos por WhatsApp"
          link="https://wa.link/4mmq82"
        />
      </div>
      <div className="mb-2 grid gap-y-4">
        <h2 className="text-xl font-extrabold text-white tracking-wide uppercase border-l-4 border-accent pl-3 bg-white/10 rounded-r-lg py-2">
          Local 10 De Agosto
        </h2>
        <Card
          logo={map}
          title="Ver en Google Maps"
          description="Abrir ubicación en Google Maps"
          link="https://maps.app.goo.gl/Gf7cmqxUZJThZbtC8"
        />
        <Card
          logo={whatsapp}
          title="Whatsapp"
          description="Contáctanos por WhatsApp"
          link="https://wa.link/mo9hkq"
        />
      </div>
    </div>
  );
}
